import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CategorySection from './components/CategorySection';
import SeoContentSection from './components/SeoContentSection';
import CtaSection from './components/CtaSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <TrustSection />
      <CategorySection />
      <SeoContentSection />
      <CtaSection />
      <FooterSection />
    </main>
  );
}